/**
 * Produces the path to the environment details page for the given environment.
 */
export function getDetailsURL(params: { environment: { id: string } }): string {
    return `/details/${params.environment.id}`;
}
